import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import GoogleCallback from './pages/GoogleCallback';
import EmbeddingProblems from './pages/EmbeddingProblems';
import { LocaleProvider } from './i18n/LocaleContext';
import { AuthProvider } from './auth/AuthContext';
import DevBanner from './components/DevBanner';
import PageErrorBoundary from './components/PageErrorBoundary';
import { isEmbedded } from './config/embedded';
import './styles/main.scss';

function App() {
  // Inside the Shopify admin iframe the portal is served from
  // /v3/shopify/app (PUBLIC_URL pins it at build time), and there is only the
  // dashboard — no landing, no login — so its pages sit at the root.
  const embedded = isEmbedded();

  return (
    <LocaleProvider>
      <AuthProvider>
        {!embedded && <DevBanner />}
        <PageErrorBoundary full>
        <Router basename={process.env.PUBLIC_URL || '/'}>
          {embedded ? (
            <Routes>
              {/* Every path is a dashboard page (/products, /stats …); the
                  API serves the shell for all of /v3/shopify/app/*. */}
              <Route path="/*" element={<Dashboard />} />
            </Routes>
          ) : (
            <Routes>
              {/* Signed out, / and /login are the same page: the landing with
                  the sign-in card (pages/Login.js); signed in, both go on to
                  the dashboard (or ?next=). */}
              <Route path="/" element={<Login />} />
              <Route path="/login" element={<Login />} />
              {/* One route for every page (/dashboard/products …), so switching
                  pages keeps the Dashboard mounted — see Dashboard.js. */}
              <Route path="/dashboard/*" element={<Dashboard />} />
              {/* Google OAuth popup lands here; it relays the token to the login tab. */}
              <Route path="/google-callback" element={<GoogleCallback />} />
              {/* Public: the embed's error messages and their fixes — no
                  sign-in, outside the dashboard (pages/EmbeddingProblems.js). */}
              <Route path="/embedding-problems" element={<EmbeddingProblems />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          )}
        </Router>
        </PageErrorBoundary>
      </AuthProvider>
    </LocaleProvider>
  );
}

export default App;
